module.exports = __webpack_public_path__ + "img/logo.13b3cd4c.png";